// Persona-agnostic ticket types + API contract. Each persona injects its own
// TicketApi (agentApi/adminApi/superApi) into the shared TicketsPage.

export interface TicketAttachment {
  id: number;
  name: string;
  mime?: string | null;
  size?: number;
}

export interface TicketMessage {
  id: number;
  user_id: number;
  author_name?: string | null;
  is_support: boolean;
  body: string;
  created_at: string;
  attachments: TicketAttachment[];
}

export interface TicketSummary {
  id: number;
  tenant_id?: number | null;
  audience: 'internal' | 'platform';
  subject: string;
  status: string;
  priority: string;
  opened_by?: number | null;
  opener_name?: string | null;
  assigned_to?: number | null;
  last_message_at?: string | null;
  updated_at?: string | null;
}

export interface TicketDetail extends TicketSummary {
  body?: string;
  messages: TicketMessage[];
}

export interface CreateTicketInput {
  audience?: 'internal' | 'platform';
  subject: string;
  body: string;
  priority?: string;
  files?: File[];
}

export interface TicketApi {
  list: (status?: string) => Promise<{ data: TicketSummary[]; unread: number }>;
  get: (id: number) => Promise<TicketDetail>;
  create: (input: CreateTicketInput) => Promise<TicketDetail>;
  reply: (id: number, body: string, files?: File[], status?: string) => Promise<TicketDetail>;
  update?: (id: number, patch: { status?: string; priority?: string }) => Promise<TicketSummary>;
  markRead: (id: number) => Promise<void>;
  attachmentUrl: (attachmentId: number) => string;
}

export const STATUS_LABEL: Record<string, string> = {
  open: 'פתוח',
  pending: 'בטיפול',
  resolved: 'נפתר',
  closed: 'סגור',
};

export const STATUS_TONE: Record<string, 'ok' | 'warn' | 'info' | 'neutral'> = {
  open: 'warn',
  pending: 'info',
  resolved: 'ok',
  closed: 'neutral',
};

export const PRIORITY_LABEL: Record<string, string> = {
  low: 'נמוכה',
  normal: 'רגילה',
  high: 'גבוהה',
  urgent: 'דחופה',
};

export const PRIORITY_TONE: Record<string, 'neutral' | 'info' | 'warn' | 'danger'> = {
  low: 'neutral',
  normal: 'info',
  high: 'warn',
  urgent: 'danger',
};
